import { useSelector } from 'react-redux';

import * as api from '../../../api';
import * as store from '../../../reducers/store';

import { PhotoIdUploadPage } from '../../Form/PhotoIdUploadPage';
import InsuranceRouter from '../../Form/InsurancePage/v2/InsuranceRouter';
import MultiInsurance from '../../Form/InsurancePage/MultiInsurance';
import PhotoIdRouter from '../../Form/PhotoIdUploadPage/v2/PhotoIdRouter';
import AllergiesPage from '../../Form/AllergiesPage';
import SurgicalHistoryPage from '../../Form/SurgicalHistoryPage';

interface Props {
  field: api.PrevisitFormField.PrevisitFormFieldWithConfig;
  updateFieldValue: (formFieldId: string, value: string) => void;
  navigateToNextPage: () => Promise<void>;
  encounter?: api.Encounter.Encounter | null;
}
const { Primitive } = api.PrevisitFormTemplateFieldConfig;

export const FullPagePrimitive = ({
  field,
  encounter,
  updateFieldValue,
  navigateToNextPage,
}: Props) => {
  const practicePreference = useSelector(
    ({ selectedFormSetId, formSets }: store.FormSetSelected) => {
      const selectedFormSet = formSets[selectedFormSetId];
      return selectedFormSet.practicePreference;
    },
  );

  if (!encounter) return null;
  switch (field.primitive) {
    case Primitive.PatientInsurance:
      return (
        <InsuranceRouter
          field={field}
          encounter={encounter}
          navigateToNextPage={navigateToNextPage}
          setFormField={updateFieldValue}
        />
      );
    case Primitive.PatientInsuranceCardPhotoUpload:
    case Primitive.PatientInsuranceCardUpload:
      return (
        <MultiInsurance
          field={field}
          setFormField={updateFieldValue}
          navigateToNextPage={navigateToNextPage}
          encounter={encounter}
        />
      );
    case Primitive.PatientPhotoId:
      return (
        <PhotoIdRouter
          field={field}
          encounter={encounter}
          setFormField={updateFieldValue}
          navigateToNextPage={navigateToNextPage}
        />
      );
    case Primitive.PatientPhotoIdUpload:
      return (
        <PhotoIdUploadPage
          field={field}
          helpDialog={field.helpDialog}
          encounter={encounter}
          setFormField={updateFieldValue}
          navigateToNextPage={navigateToNextPage}
        />
      );
    case Primitive.PatientAllergies:
      return (
        <AllergiesPage
          field={field}
          navigateToNextPage={navigateToNextPage}
          setFormField={updateFieldValue}
          practicePreference={practicePreference}
        />
      );
    case Primitive.PatientSurgicalHistory:
      return (
        <SurgicalHistoryPage
          field={field}
          navigateToNextPage={navigateToNextPage}
          setFormField={updateFieldValue}
        />
      );
    default:
      return null;
  }
};
